<template>
  <Modal title="拒绝结算" v-model="visible">
    <Form ref="fundForm" class="form"
          :model="fundParam" :rules="fundRule"
          :label-width="80">
      <Row>
        <Col :span="22">
        <Form-item label="拒绝理由" prop="reason">
          <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                 placeholder="长度不要超过100个字符"
                 v-model="fundParam.reason"></Input>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingBalance" @click="balance">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'RejectBalanceModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        fundParam: {
          reason: ''
        },
        loadingBalance: false,
        fundRule: {
          reason: [
            {required: true, message: '请输入拒绝理由', trigger: 'blur'},
            {type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      balance () {
        this.loadingBalance = true
        this.$refs.fundForm.validate(valid => {
          if (!valid) {
            this.$Message.warning('信息输入错误!')
            this.loadingBalance = false
            return
          }
          this.loadingBalance = false
          this.visible = false
          this.$http.post('/bookLesson/balanceBookFail', {reason: this.fundParam.reason, id: this.openedId}).
            then(res => {
              if (res) {
                this.successCallback()
                this.$Message.success('处理成功!')
                this.visible = false
                return
              }
            })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RejectBalanceModal.vue?14abb598